import React from 'react';
import { Route, Link } from "react-router-dom";
import LazyLoad from 'react-lazyload';
import ReactHtmlParser from 'react-html-parser';

// const _works = [
//     // die einzelnen unterseiten von works
//     {id: 1, title: 'Copy',    url: 'copy',    img: '/img/cbr_copy.jpg', sub: [
//
//         // die eintraege in der jeweiligen unterseite, mit titel + bilder
//         { id: 1,
//           title: "title 1",
//           text: "utnheunt hunoe uoneuhoenu heonu heuneoh usntoauhe",
//           imgs: [
//             { id: 1, url: "/demo/test_560_half.jpg", style: 'half'},
//             { id: 2, url: "/demo/test_1140_full.jpg", style: 'full'},
//             { id: 3, url: "/demo/test_560_half.jpg", style: 'center'},
//           ]
//         },
//
//         { id: 2,
//           title: "title 2",
//           text: "utnheunt hunoe uoneuhoenu heonu heuneoh usntoauhe",
//           imgs: [
//             { id: 1, url: "/demo/test_560_half.jpg", style: 'half_l'},
//             { id: 4, url: "/demo/test_560_half.jpg", style: 'half_r'},
//             { id: 2, url: "/demo/test_1140_full.jpg", style: 'full'},
//             { id: 3, url: "/demo/test_560_half.jpg", style: 'center'},
//             { id: 5, url: "/demo/test_560_half.jpg", style: 'half_r'},
//           ]
//         }
//
//       ]
//     },
//     {id: 2, title: 'Film',      url: 'film',    img: '/img/cbr_film.jpg'},
//     {id: 3, title: 'Cases',     url: 'cases',   img: '/img/cbr_cases.jpg'},
//     {id: 4, title: '360\u00B0', url: '360',     img: '/img/cbr_360.jpg'},
//     {id: 5, title: 'Various',   url: 'various', img: '/img/cbr_various.jpg'}
// ];


// --------------------------------------------------------------------------------------
//  WORK
// --------------------------------------------------------------------------------------

  const Work = (props) => (
      <WorkTileMosaic works={ props.workdata } />
  )

  // class Work extends React.Component {
  //
  //     render() {
  //
  //       return(
  //           <WorkTileMosaic works={ this.props.workdata } />
  //       );
  //     }
  // }


  /**
   * Easier with CSS, but who knows what we have to do later, mostly just wanted to know how it works ;p
   */
  class WorkTile extends React.Component {

    constructor(props) {
      super(props);
      this.state = {hovered: false};
    };

    onHover() {
      this.setState({ hovered: !this.state.hovered });
    };

    render() {

      let classes = "cb-onlyhover";
      if (this.state.hovered) classes += " cb-hover";

      let url = '/work/' + this.props.work.url;

      return (
          <Route
              path={url}
              children={({ match }) => (
                  <Link
                      to={url}
                      className="cb-work-tile"
                      style={{backgroundImage: `url(${process.env.PUBLIC_URL + this.props.work.img})`}}
                      onMouseOut={() => {this.onHover();}}
                      onMouseOver={() => {this.onHover();}}>

                    <img src={process.env.PUBLIC_URL + "/img/560x315_white.png"}
                         alt="spaceholder"
                         className={'cb-spaceholder ' + classes} />

                    <div className={"cb-work-title " + classes}>
                      { ReactHtmlParser (this.props.work.title) }
                    </div>

                  </Link>
              )}
          />
      );
    }
  };


  const WorkTileMosaic = (props) => {
    const works = props.works;
    const workTiles = works.map((work) =>
        <WorkTile key={work.id}
                  work={work} />
    );
    return (
        <div className="cb-work-tile-mosaic clearfix">{workTiles}</div>
    );
  }


// --------------------------------------------------------------------------------------








// --------------------------------------------------------------------------------------
//    WORKSUB
// --------------------------------------------------------------------------------------

  class WorkSubTileImage extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
        izVideo: ( (typeof props.data.video !== "undefined") && (props.data.video === true) )
      };
    };

    wazClicked() {
      if (this.state.izVideo) {
        this.props.openPopup( this.props.data.vidurl, this.props.data.vidthumb );
      }
    }

    // componentDidUpdate() {
    //   console.log('WorkSubTileImage didupdate');
    // }

    render() {
      let title, text, infobox, alt;
      alt = "";

      // TRY to get title
      if (typeof this.props.data.title !== "undefined") {
        title = <div className="cb-img-title">{ ReactHtmlParser (this.props.data.title)}</div>
        alt += this.props.data.title;
      }
      // TRY to get text
      if (typeof this.props.data.text !== "undefined") {
        text = <div className="cb-img-text">{this.props.data.text}</div>
        if (alt !== "") {
          alt += " - ";
        }
        alt += this.props.data.text;
      }
      // IF we have any of them, show it
      if (typeof title !== "undefined" || typeof text !== "undefined") {
        infobox = <div className="cb-img-infobox">{title}{text}</div>
      }

      if ((typeof this.props.data.alt !== "undefined") && (this.props.data.alt !== "")) {
        alt = this.props.data.alt;
      }

      let hazSTitle = (typeof this.props.data.subtitle !== "undefined")
      let hazSText  = (typeof this.props.data.subtext !== "undefined")
      let hazSub = hazSText || hazSTitle

      return (
          <div onClick={ () => {this.wazClicked()} }
               className={"cb-linkimg " + this.props.data.style + (this.state.izVideo ? " cb-video" : "")
               + (hazSub ? ' cb-with-subinfo' : '')}>
            <LazyLoad height={200}>
              <img src={process.env.PUBLIC_URL + this.props.data.url} alt={alt}/>
              {hazSTitle || hazSText ? (
                <div className={"cb-imginfo"}>
                  {hazSTitle ? (
                    <div className={"cb-subtitle"}>{ this.props.data.subtitle }</div>
                  ) : ('')}
                  {hazSText ? (
                    <div className={"cb-subtext"}>{ this.props.data.subtext }</div>
                    ) : ('')}
                </div>
              ) : ('')}

            </LazyLoad>
            {infobox}
          </div>
      );
    }
  }


  const WorkSubTile = ({data, openPopup}) => {

    const images = data.imgs.map((img) =>
        <WorkSubTileImage
            key={img.id}
            data={img}
            openPopup={ openPopup }/>
    );

    const hazTitle = (typeof data.title !== "undefined")
    const hazText  = (typeof data.text !== "undefined")
    const doShow = hazText || hazTitle

    return (
        <div className={"cb-worksub-tile"}>

          {images}

          {doShow ? (
          <div className={"cb-imginfo"}>

            <div className={"cb-subtitle"}>
              { ReactHtmlParser (data.title) }
            </div>

            <div className={"cb-subtext"}>
              { ReactHtmlParser (data.text) }
            </div>

          </div>
          ) : ('')}
        </div>
    )
  }


  class WorkSub extends React.Component {

    getSubData(slug) {
      let ret = [];
      this.props.workdata.forEach(function(entry) {
        if (entry.url === slug) {
          ret = entry;
          return entry;
        }
      });
      return ret;
    }

    render() {

      let slug = this.props.match.params.id;
      let subdata = this.getSubData(slug)

      if ( (typeof subdata.sub !== "undefined") && (subdata.sub.length) ) {

        // HAS DATA, show subpage
        // ---------------------------

        const workSubTiles = subdata.sub.map((sub) =>
            <WorkSubTile  key={sub.id}
                          data={sub}
                          openPopup={ this.props.openPopup }/>
        );

        return(
            <div className={"cb-worksub"}>
              <h2>{ ReactHtmlParser (subdata.title) }</h2>
              {workSubTiles}
            </div>
        );

      }
      else {

        // EMPTY, no data
        // ---------------------------
        return(
            <div>
              No data for {slug}
            </div>
        )
      }
    }

  }

// --------------------------------------------------------------------------------------










class Popup extends React.Component {

  // called once per element
  constructor(props) {
    super(props);
    this.state = {
      hovered: false,
      url: "",
      urlChange: false
    };
    // recerence to use on video element (could be used wherever for whatever)
    this.refVideoElement = React.createRef();
  };

  /**
   * Prevent click on video element from bubbling up and closing the popup
   **/
  izClicked(e) {
    e.stopPropagation();
  }

  /**
   * Pausing the HTML5 video
   **/
  stopVideo() {
    this.refVideoElement.current.pause()
  }


  componentDidUpdate() {

    // restart video if there has been an url change
    if ( this.state.urlChange && this.props.show ) {
      this.refVideoElement.current.load();
    }
  }

  // 'nother solution as per https://stackoverflow.com/a/34999925/826194 if page has to be painted before action
  // onNextFrame(callback) {
  //   setTimeout(function () {
  //     window.requestAnimationFrame(callback)
  //   }, 0)
  // }


  static getDerivedStateFromProps(props, state) {
    if (props.vidurl !== state.url) {
      return {
        url: props.vidurl,
        urlChange: true
      };
    }
    return null;
  }


  render() {

    // console.log('POPOP: render', this.props);

    let video = "";

    if ( (typeof this.props.vidurl !== "undefined") && (this.props.vidurl !== "") ) {
      video = (
          <video width="1280" controls autoPlay onClick={ this.izClicked } ref={this.refVideoElement}>
            <source src={ process.env.PUBLIC_URL + this.props.vidurl + ".mp4" } type="video/mp4" />
            {/*<source src={ this.props.vidurl + ".webm"} type="video/ogg" />*/}
            Your browser does not support the video tag.
          </video>
      )

    }


    return(

        <div className={"cb-popup" + (this.props.show?" open":"")} ref={this.myRef} onClick={this.props.closePopup}>
          <div className="cb-popup-content">
            <div className={"cb-popup-video"}>
              {video}
            </div>
          </div>
        </div>

    );
  };


}







export { Work, WorkSub, Popup };


// WEBPACK FOOTER //
// ./src/includes/Work.jsx